// chooseserverform.ts ↔ game/chooseserverform.cpp — the CHOOSE SERVER form's
// shared constants + the ServerInfo record (kidfChooseServer, forms.ini 1076).
// The canvas ChooseServerForm class was removed (canvas-removal R1); the DOM
// lobby drives the serverinfo fetch / connect now (dom/lobby-controller.ts,
// which reuses kszServerInfoUrl + ServerInfo).

export const kidfChooseServer = 1076;
export const kidcServerList = 1300;
export const kidcServerName = 1301;
export const kidcServerLocation = 1302;
export const kidcServerStatus = 1303;
export const kidcRefresh = 1304;
export const kidcNumPlayers = 1003;

// game/chooseserverform.h knChooseServerResult*
export const knChooseServerResultConnect = 0;
export const knChooseServerResultCancel = 1;
export const knChooseServerResultAppStop = 2;

// game/serviceurls.cpp:25 (the production block)
export const kszServerInfoUrl = 'https://api.warfareincorporated.com/api/serverinfo';

// game/chooseserverform.h ServerInfo
export interface ServerInfo {
  sort_key: number;
  name: string;
  location: string;
  address: string; // base::SocketAddress "host:port" (native clients)
  protocol: number;
  status: string;
  player_count: number;
  type: string;
  disallow: string;
  websocket_proxy: string; // the WEB client's actual connect target
}
